import swal from "sweetalert";
import { loginConfirmedAction, Logout, refreshAccessToken} from '../store/actions/AuthActions';
import {loadProfile} from '../store/actions/ProfileAction'
import axiosAuthInstance from './AxiosAuthInstance';
import AxiosInstance from './AxiosInstance';
export function signUp(formData) {
    return axiosAuthInstance.post(`auth/register`,formData);
}

export function verifyUserOTP(formData) {
    return axiosAuthInstance.post(`auth/verify-otp`,formData);
}

export function login(payload) {
    const postData = {
        email: payload.email,
        password: payload.password,
        location: payload.location || null,
        ipAddress: payload.ipAddress || null,
        returnSecureToken: true,
    };
    console.log('postData', postData)
    return axiosAuthInstance.post(`auth/login`, postData);
}

export function formatError(errorResponse) {
    console.log('errorResponse', errorResponse.error)
    switch (errorResponse.message) {
        case 'EMAIL_EXISTS':
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           break;
        case 'INVALID_PASSWORD':
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            break;
        case 'USER_DISABLED':
            return 'User Disabled';

        case errorResponse.error:
            console.log('checkData12', errorResponse.error)
            swal("Oops", errorResponse.error, "error",{ button: "Try Again!",});
            break;
            
        case errorResponse.message:
            console.log('checkData13', errorResponse.error, errorResponse.message)
            swal("Oops", errorResponse.error || errorResponse.message, "error",{ button: "Try Again!",});
            break;

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails, userDetails={}) {
    localStorage.setItem('LNT', tokenDetails.accessToken);
    localStorage.setItem('EXPT', tokenDetails.refreshToken);
    localStorage.setItem('userDetails', JSON.stringify(userDetails));
}

export const refreshAccessTokenMain = async () => {
    try {
      const { store } = require('../store/store');
      const state = store.getState();
      const response = await AxiosInstance.post(`/auth/refresh-token`,
            { token: state?.auth?.auth.refreshToken },
            { withCredentials: true }
      )
      const newToken = response?.data?.data?.accessToken;
      localStorage.setItem('LNT', newToken);
      store.dispatch(refreshAccessToken(newToken));
      return newToken;
    } 
    catch (err) {
      console.error('Token refresh failed', err);
    }
};

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        dispatch(Logout(navigate));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';

    // Normalize pathname so casing/extra query params don't accidentally bypass the login/register check.
    const path = window.location.pathname.toLowerCase();
    const isAuthRoute = path.startsWith('/login') || path.startsWith('/register');

    if (!tokenDetailsString && !isAuthRoute) {
        dispatch(Logout(navigate));
        return;
    }

    if (!isAuthRoute) {
        tokenDetails = JSON.parse(tokenDetailsString);
        let expireDate = new Date(tokenDetails.expireDate);
        let todaysDate = new Date();

        if (todaysDate > expireDate) {
            dispatch(Logout(navigate));
            return;
        }

        dispatch(loginConfirmedAction(tokenDetails));
        const timer = expireDate.getTime() - todaysDate.getTime();
        runLogoutTimer(dispatch, timer, navigate);
        dispatch(loadProfile());
    }
}

